/* eslint-disable no-nested-ternary */
import React from 'react'

import Icon from '../icon'

import * as S from './styles'

import IProps from './props'

const ContractorProfileSection = ({
  title,
  children,
  isEditing,
  noEditable,
  onEdit,
  handleEditPlan,
}: IProps) => (
  <S.Container>
    <S.SubContainer>
      <S.Title>
        {title}
        {' '}
        {title === 'Seu plano' && (
          <S.SubTitle>(somente você pode visualizar isto)</S.SubTitle>
        )}
      </S.Title>
      {noEditable ? null : isEditing ? (
        <S.CancelButton onClick={onEdit}>
          <Icon name="close" />
          {' '}
          Cancelar
        </S.CancelButton>
      ) : (
        <S.EditButton onClick={title === 'Seu plano' ? handleEditPlan : onEdit}>
          <Icon name="edit-hollow" />
          {' '}
          Editar
        </S.EditButton>
      )}
    </S.SubContainer>
    <S.Content>{children}</S.Content>
  </S.Container>
)

export default ContractorProfileSection
